import React, { useEffect, useState } from 'react';
import { IPresentationListing } from '../../../../entities-generated/models/presentation/presentation-listing';
import { BwjSidePanel } from '../../../../framework/components/bwj-side-panel';
import { xlate, xlationContext } from '../../../../framework/utils/i18n';
import { BwjGrid } from '../../../../framework/components/bwj-layout';
import { Spacing } from '../../../../framework/components/bwj-layout/styles';
import { RowCol } from '../../../../framework/components/bwj-layout/rowcol';
import { ActionButton } from '@fluentui/react';

xlationContext('Discussion plan listing mobile screen context menu panel');

export interface ILaunchDiscussionListingMenuPanelArgs {
  presentation: IPresentationListing;
}

interface IDiscussionListingMenuPanelProps {
  launchPanel: ILaunchDiscussionListingMenuPanelArgs | undefined;
  onEditPresentation: (presentation: IPresentationListing) => void;
  onClonePresentation: (presentation: IPresentationListing) => void;
  onBeginPresentation: (presentation: IPresentationListing) => void;
  onEndPresentation: (presentation: IPresentationListing) => void;
  onDeletePresentation: (presentation: IPresentationListing) => void;
}

export const DiscussionListingMenuPanel: React.FunctionComponent<IDiscussionListingMenuPanelProps> = (props) => {
  const args = props.launchPanel;
  const [showPanel, setShowPanel] = useState(false);

  useEffect(() => {
    setShowPanel(args !== undefined);
  }, [args]);

  const onEditPresentation = () => {
    setShowPanel(false);
    props.onEditPresentation(args!.presentation);
  };
  const onClonePresentation = () => {
    setShowPanel(false);
    props.onClonePresentation(args!.presentation);
  };
  const onBeginPresentation = () => {
    setShowPanel(false);
    props.onBeginPresentation(args!.presentation);
  };
  const onEndPresentation = () => {
    setShowPanel(false);
    props.onEndPresentation(args!.presentation);
  };
  const onDeletePresentation = () => {
    setShowPanel(false);
    props.onDeletePresentation(args!.presentation);
  };

  return (
    <>
      {!!args &&
      <BwjSidePanel
        showPanel={showPanel}
        title={args.presentation.title}
        onDismiss={() => setShowPanel(false)}
        isLightDismiss={true}
        closeButtonAriaLabel={xlate('Close discussion plan context menu panel')}
      >
        <BwjGrid>
          <RowCol bottomSpacing={Spacing.Medium}>
            <ActionButton
              iconProps={{ iconName: 'Play'}}
              onClick={onBeginPresentation}
            >
              {args.presentation.inProgress ? xlate('Resume discussion') : xlate('Start discussion')}
            </ActionButton>
          </RowCol>
          {args.presentation.inProgress &&
          <RowCol bottomSpacing={Spacing.Medium}>
            <ActionButton
              iconProps={{ iconName: 'Stop'}}
              onClick={onEndPresentation}
            >
              {xlate('End discussion')}
            </ActionButton>
          </RowCol>}
          <RowCol bottomSpacing={Spacing.Medium}>
            <ActionButton
              iconProps={{ iconName: 'Edit'}}
              onClick={onEditPresentation}
            >
              {xlate('Edit discussion plan')}
            </ActionButton>
          </RowCol>
          <RowCol bottomSpacing={Spacing.Medium}>
            <ActionButton
              iconProps={{ iconName: 'Copy'}}
              onClick={onClonePresentation}
            >
              {xlate('Create copy')}
            </ActionButton>
          </RowCol>
          <RowCol bottomSpacing={Spacing.Medium}>
            <ActionButton
              iconProps={{ iconName: 'Delete'}}
              onClick={onDeletePresentation}
            >
              {xlate('Delete discussion plan')}
            </ActionButton>
          </RowCol>
        </BwjGrid>
      </BwjSidePanel>}
    </>
  );
};
